import React, { useEffect, useState } from 'react'
import "./styleCss/RoleManage.css"
import Header from "../template/Header";
import Menu from "../template/Menu";
import Footer from "../template/Footer";
import Loading from "../components/loading/Loading";
import { Button, Col, Row } from "react-bootstrap";
import Dropdown from "../components/dropdowns/Dropdown"
import TableData from "../components/table/TableData"
import { getRole, deleteRole} from "../api/role_api";
import formatDatetime from "../utils/formatDateTime.js";
import {
    textSearchBtn,
    textResetBtn,
    textCreateBtn,
    colorSearchBtn,
    colorResetBtn,
    colorCreateBtn,
    iconSearchBtn,
    iconResetBtn,
    iconCreateBtn,
    hoverSearchBtn,
    hoverResetBtn,
    hoverCreateBtn,
    textSaveBtn,
    textCancleBtn,
    colorSaveBtn,
    colorCancleBtn,
    hoverSaveBtn,
    hoverCancleBtn,
    colorEditBtns,
    hoverEditBtns
} from "../components/ThemeConfig/btnConfig";
import { useButtonDynamicStyles } from "../components/useDynamic/Button_DynamicStyle";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight,faMagnifyingGlass,faPlus } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { alertMinus } from "../components/alertValid/AlertValid.js";

function RoleManage() {
    useButtonDynamicStyles(
        textSearchBtn,
        textResetBtn,
        textCreateBtn,
        colorSearchBtn,
        colorResetBtn,
        colorCreateBtn,
        iconSearchBtn,
        iconResetBtn,
        iconCreateBtn,
        hoverSearchBtn,
        hoverResetBtn,
        hoverCreateBtn,
        textSaveBtn,
        textCancleBtn,
        colorSaveBtn,
        colorCancleBtn,
        hoverSaveBtn,
        hoverCancleBtn,
        colorEditBtns,
        hoverEditBtns
    );
    
    const [isLoading, setLoading] = useState(false);

    const [inputForm, setInputForm] = useState({
        role: 0,
    });

    function setinput(inputname, value) {
        setInputForm((prev) => {
            return {
                ...prev,
                [inputname]: value,
            };
        });
    }

    const [valuefromparent1, setValuefromparent1] = useState("Role All");
    const [selectedRole, setSelecteRole] = useState("");
    const [dataTable, setDatatable] = useState([]);
    const [DataDropRole, setDataDropRole] = useState([]);

    const handleRoleChange = (value) => {
        setSelecteRole(value);
    };

    const ChangesetValuefromparent1 = (text) =>  {
        setValuefromparent1(text);
    }
    
    const navigate = useNavigate();
    const navigateToAddPage = () => {
        navigate("/a&eInfoRoleManage");
    };

    const dataHeader = [
        { label: "No",column:'no' , style: { width: "10%", borderLeft: "1px solid #000",borderTopLeftRadius: "10px",borderTopRightRadius: "0px",borderBottomLeftRadius: "10px"
        ,borderBottomRightRadius: "0px",position:'relative' },status: true
        },
        { label: "Role",column:'role', style: { width: "20%",borderRadius: "0px",position:'relative' }, status: true },
        { label: "Update",column:'updated_at', style: { width: "25%",borderRadius: "0px",position:'relative' }, status: true },        
        { label: "Status",column:'active' , style: { width: "20%",borderRadius: "0px",position:'relative' }, status: true },
        { label: "Action",column:'action', style: { width: "10%",borderRight: "1px solid #000",borderTopRightRadius: "10px",borderTopLeftRadius: "0px",borderBottomRightRadius: "10px",borderBottomLeftRadius: "0px"
        ,position:'relative' } }
    ];
    const [tableParam, setTableParam] = useState({
        sorting:{ column: "", order: "" },
        pageNumber:1,
        dataPerPage:10,
    }); //กำหนด column เริ่มต้นในการ sort
    const [totalNumber, setTotalNumber] = useState(0)
    useEffect(()=>{
        getTableDataRole()
    },[tableParam])

    const sortTable = (newSorting) => {
        setTableParam((prevTableParam) => ({
            ...prevTableParam,
            sorting: newSorting,
        }));   
    };    
    const changePage = (pageNumber) => {
        setTableParam((prevTableParam) => ({
            ...prevTableParam,
            pageNumber: pageNumber,
        }));   
      //newSorting example 1
    };
    const changeDataPerPage = (dataPerPage) => {
        setTableParam((prevTableParam) => ({
            ...prevTableParam,
            dataPerPage: dataPerPage,
          }));   
      //newSorting example 10
    };

    const getRoleDropDown = async () => {
        try {
            const response = await getRole();
            if (response.status == 200) {
                let dataRole = [{ value: "", text: "Role All" }];
                response.data.data.forEach((item, i) => {
                    return dataRole.push({
                        value: item._id,
                        text: item.role_name,
                    });
                });
                setDataDropRole(dataRole);
            }
        } catch (error) {
            console.log(error);
        }
    };

    async function getTableDataRole() {
        try {
            await setLoading(true);
            const param = {
                role_id:selectedRole,
                sort_by:tableParam.sorting.column=='no'?'_id':tableParam.sorting.column,
                order_by:tableParam.sorting.order,
                page_number:tableParam.pageNumber,
                data_per_page:tableParam.dataPerPage,
            }
            let response = await getRole(param);
            let tmpDataTable = [];
            setTotalNumber(response.data.meta.total)
            for (let i = 0; i < response.data.data.length; i++) {
                const ascendingNo = { data: (i + 1)+((tableParam.pageNumber-1)*tableParam.dataPerPage) };
                const descendingNo = { data: response.data.meta.total - ((tableParam.pageNumber - 1) * tableParam.dataPerPage) - i };
                let model = {
                    no: tableParam.sorting.order == 'desc'&& tableParam.sorting.column=='no' ?
                            descendingNo:ascendingNo,
                    user_id: {
                        data: response.data.data[i]._id,
                        isHide: true,
                    },
                    role: { data: response.data.data[i].role_name },
                    updated_at: {
                        data: (response.data.data[i]?.update_by ?? ' - ') + ' | ' + formatDatetime(response.data.data[i].updated_at),
                    },
                    active: {
                        data: response.data.data[i].active === 1 ? "Active" : "Inactive",
                        style: {
                            color: response.data.data[i].active === 1 ? "#87BD66" : "#D95350",
                        },
                    },
                    action: {
                        view: false,
                        create: false,
                        delete: false,
                        update: false,
                        edit: true,
                    },
                };
                tmpDataTable.push(model);
            }
            setDatatable(tmpDataTable)
        } catch (error) {
            console.log('err getTableDataUser',error)
        }
        await setLoading(false);
    }

    const handleSearchBtn = async () => {
        getTableDataRole();
    };

    useEffect(()=>{
        getTableDataRole();
        getRoleDropDown();
    },[])

  return (
    <>
        {isLoading ? <Loading /> : ""}
        <Header parentmenu={"ADMIN USER"} />
        <Menu
            parentmenu={"infoAdminUser"}
            activemenu={"infoRoleManage"}
        />
        <div className="content-wrapper">
            <div className="container-fluid pdb-page">
            <div className="box-white">
                    <Row>
                        <Col xs={12}>
                            <font className="font-size07 colorBlack01 fontBold d-flex align-items-center">
                                <img src="assets/icons/ic-users.png" className="ic-user01 me-2" alt="" />
                                ADMIN USER<FontAwesomeIcon icon={faChevronRight} className="h-8 p-2" /> ROLE MANAGE
                            </font>
                        </Col>
                    </Row>
                    <Row className="mt-4">
                        <Col xs={3}>
                            <Button className="btn-create" onClick={() => navigateToAddPage()}>
                                <FontAwesomeIcon icon={faPlus} className="colorWhite me-2"/>
                                Add
                            </Button>
                        </Col>
                        <Col xs={9}>
                            <Row>
                                <Col xs={10} className="d-flex justify-content-end align-items-center">
                                    <label className="fontLight font-size01 colorBlack01 mb-0 me-2">
                                        Role:
                                    </label>
                                    <Dropdown
                                        options={DataDropRole}
                                        setinput={setinput}
                                        inputname={"role"}
                                        ChangesetValuefromparent={ChangesetValuefromparent1}
                                        valuefromparent={valuefromparent1}
                                        onChange={handleRoleChange}
                                    />
                                </Col>
                                <Col xs={2} className="d-flex justify-content-end">
                                    <Button className="btn-search"
                                        onClick={(e) => {
                                            handleSearchBtn(selectedRole);
                                        }}
                                    >
                                        
                                        <FontAwesomeIcon icon={faMagnifyingGlass} className="colorBlack01 me-2"/>
                                        Search
                                    </Button>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row>
                        <TableData
                            dataHeader={dataHeader}
                            editUrl={"/a&eInfoRoleManage?id="}
                            dataTable={dataTable}
                            idName={"user_id"}
                            removeData={(id) => alertMinus(id, deleteRole)}
                            tableParam={tableParam}
                            sortTable={sortTable}
                            changePage={changePage}
                            changeDataPerPage={changeDataPerPage}
                            totalNumber={totalNumber}
                            tablePermission={{
                                view: false,
                                create: false,
                                delete: false,
                                update: false,
                                edit: true,
                            }}
                        />
                    </Row>
                </div>
            </div>
        </div>
        <Footer/>
    </>
  )
}

export default RoleManage;